import React from 'react';
import Icon from '../../../components/AppIcon';

const CompletionIndicator = ({ blocks }) => {
  const totalBlocks = blocks?.length;
  const completedBlocks = blocks?.filter(block => block?.value && block?.value?.length > 50)?.length;
  const completionPercentage = Math.round((completedBlocks / totalBlocks) * 100);

  const getStatusColor = () => {
    if (completionPercentage >= 80) return 'success';
    if (completionPercentage >= 50) return 'warning';
    return 'muted';
  };

  const statusColor = getStatusColor();

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 elevation-sm">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className={`w-10 h-10 rounded-lg bg-${statusColor}/20 flex items-center justify-center`}>
            <Icon
              name={completionPercentage === 100 ? 'CheckCircle2' : 'Target'}
              size={20}
              color={`var(--color-${statusColor})`}
            />
          </div>
          <div>
            <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
              Canvas Completion
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground font-caption">
              {completedBlocks} of {totalBlocks} blocks completed
            </p>
          </div>
        </div>
        <div className="text-right">
          <p className={`text-2xl md:text-3xl font-heading font-bold text-${statusColor}`}>
            {completionPercentage}%
          </p>
        </div>
      </div>

      <div className="relative h-3 bg-muted rounded-full overflow-hidden">
        <div
          className={`absolute inset-y-0 left-0 bg-${statusColor} transition-smooth rounded-full`}
          style={{ width: `${completionPercentage}%`, transitionDuration: '500ms' }}
        />
      </div>

      {completionPercentage < 100 && (
        <p className="mt-3 text-xs text-muted-foreground font-caption">
          Complete all blocks to unlock strategy report generation
        </p>
      )}
    </div>
  );
};

export default CompletionIndicator;